import { PUBLIC_DEALS_RETAILERS } from "../config/publicDeals";
import type { ProductType } from "../context/ProductContext";

const normalizeOnlineProductType = (retailer: string) =>
  retailer === "walmart_online"
    ? "walmart"
    : retailer === "target_online"
      ? "target"
      : retailer;

export const BASELINE_ONLINE_PRODUCT_TYPES = PUBLIC_DEALS_RETAILERS.map(
  (retailer) => normalizeOnlineProductType(retailer.apiRetailer) as ProductType
);

export const isBaselineOnlineProductType = (retailer: ProductType) =>
  BASELINE_ONLINE_PRODUCT_TYPES.includes(
    normalizeOnlineProductType(retailer) as ProductType
  );

export const hasBaselineOnlineModeAccess = (
  retailer: ProductType,
  mode: "in_store" | "online"
) => mode === "online" && isBaselineOnlineProductType(retailer);
